import React from 'react';
import { windowLogger } from '../../Logger/windowLogger';

export type HeadingHierarchy = 2 | 3 | 4 | 5 | 6;

type HeadingProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
  hierarchy: HeadingHierarchy;
  ref?: React.RefObject<HTMLHeadingElement | null> | null;
};

/**
 * A dynamic Heading component.
 * */
function Heading({ hierarchy, ref, ...props }: HeadingProps) {
  if (hierarchy > 6) {
    windowLogger.warn('Encountered a hierarchy which is > 6 and not supported');
    return null;
  }
  return React.createElement(`h${hierarchy}`, { ...props, ref });
}

export { Heading };
